"use strict";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

import { SvgIconType } from '../../SvgIcon/svg-icon-type.mjs';
import { filterOptionsByLabel } from './utils.mjs';

var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, key + "" , value);
class ConstantOptionFactory {
  constructor(options) {
    __publicField(this, "options", options);
  }
  async getOptions({ input }) {
    return this.getOptionsSync({ input });
  }
  getOptionsSync({ input }) {
    return filterOptionsByLabel(this.options, input).map((option) => ({
      ...option,
      iconType: SvgIconType.ListOption
    }));
  }
}

export { ConstantOptionFactory };
